export default "__VITE_ASSET__BrHd6rDX__"